var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentOrLoading',[(_vm.svg)?_c('ShowSvgSectionsComponent',{attrs:{"secciones":_vm.secciones,"zona_id":_vm.zona_id,"svg":_vm.svg,"strictRegions":_vm.strictRegions},on:{"clickZona":_vm.clickRegion}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }